import { Table } from '../../../common/components';
import { bulkTableColumn } from '../../../utils/constant';
import BulkStatementTableRow from './bulkStatementTableRow';

const BulkStatementTable = ({
  data,
  onPurchaserOpiClick,
  slNo,
  onHeaderCheckedChange,
  rowCheckChanged,
  checkHeader,
  rowsChecked,
  selectAll,
  // selectDue,
  rowsUnChecked,
}) => {
  const isCheckedValue = (rowData) => {
    if (selectAll) {
      return !rowsUnChecked[`${rowData?.bills}_${rowData?.onePortalId}`];
    }
    // if (selectDue && rowData?.balanceDue > 0) {
    //   return !rowsUnChecked[`${rowData?.bills}_${rowData?.onePortalId}`];
    // }
    return rowsChecked[`${rowData?.bills}_${rowData?.onePortalId}`];
  };
  return (
    <Table
      headers={bulkTableColumn}
      bordered
      responsive
      isCheckboxRequired
      className="dashboard-table bulk-statement-table"
      checked={checkHeader}
      onCheckChanged={onHeaderCheckedChange}
      checkBoxDisabled={selectAll}
    >
      <tbody>
        {data?.map((rowData, rowNumber) => (
          <BulkStatementTableRow
            key={`${rowData?.bills}_${rowData?.onePortalId}`}
            slNo={slNo + rowNumber + 1}
            rowData={rowData}
            index={rowNumber}
            rowCheckChanged={rowCheckChanged}
            checked={isCheckedValue(rowData) || false}
            onPurchaserOpiClick={onPurchaserOpiClick}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default BulkStatementTable;
